import { Component } from '@angular/core';

@Component({
  selector: 'ngx-licenceskey',
  template: `<router-outlet></router-outlet>`,
})
export class LicenceKeysComponent {
}
